import { render, staticRenderFns } from "./batchTagsPopup.vue?vue&type=template&id=6de3820b&scoped=true&"
import script from "./batchTagsPopup.vue?vue&type=script&lang=js&"
export * from "./batchTagsPopup.vue?vue&type=script&lang=js&"
import style0 from "./batchTagsPopup.vue?vue&type=style&index=0&id=6de3820b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3820b",
  null
  
)

export default component.exports